/* eslint-disable */
/*
  FOOTY ANALYST — REAL FOOTBALL DATA
  =====================================
  Sources:
    • Club/league data: OpenFootball (public domain, CC0)
    • Fixture structure: OpenFootball england repo
    • xG calibration: StatsBomb Open Data (credit required on publish)
    • Form/results: football-data.org free tier (API key required)

  This file provides:
    1. ALL_CLUBS         — 88 real semi-pro clubs with ground/capacity data
    2. COMPETITIONS      — real competition names and tiers
    3. REAL_FIXTURES_24  — 2024/25 National League sample fixtures
    4. XG_CALIBRATION    — shot quality benchmarks from StatsBomb open data
    5. fetchRealFixtures  — live fetch from football-data.org free API
    6. fetchOpponentForm  — fetch recent results for any club
*/

/* ═══════════════════════════════════════════════
   1. REAL CLUBS — National League pyramid 2024/25
   OpenFootball (CC0 public domain)
═══════════════════════════════════════════════ */
export const CLUBS = {

  // TIER 5 — National League (Vanarama)
  nationalLeague: [
    { name:"Aldershot Town",      short:"Aldershot",  county:"Hampshire",       ground:"EBB Stadium",              capacity:7100,  colours:"Red & Blue"    },
    { name:"Altrincham FC",       short:"Altrincham", county:"Gtr Manchester",  ground:"J.Davidson Stadium",       capacity:6085,  colours:"Red & White"   },
    { name:"Barnet FC",           short:"Barnet",     county:"London",          ground:"Underhill Stadium",        capacity:5500,  colours:"Black & Amber" },
    { name:"Boreham Wood FC",     short:"Boreham Wd", county:"Hertfordshire",   ground:"Meadow Park",              capacity:4502,  colours:"White & Black" },
    { name:"Boston United FC",    short:"Boston",     county:"Lincolnshire",    ground:"Jakemans Community Stad.", capacity:6000,  colours:"Amber & Black" },
    { name:"Bromley FC",          short:"Bromley",    county:"London",          ground:"Hayes Lane",               capacity:5000,  colours:"Black & White" },
    { name:"Chesterfield FC",     short:"Chesterfield",county:"Derbyshire",     ground:"SMH Group Stadium",        capacity:10400, colours:"Blue & White"  },
    { name:"Dagenham & Redbridge",short:"Dag & Red",  county:"Essex",           ground:"Victoria Road",            capacity:6078,  colours:"Red & Blue"    },
    { name:"Eastleigh FC",        short:"Eastleigh",  county:"Hampshire",       ground:"Silverlake Stadium",       capacity:5250,  colours:"White & Blue"  },
    { name:"FC Halifax Town",     short:"Halifax",    county:"West Yorkshire",  ground:"MBI Shay Stadium",         capacity:14000, colours:"Blue & White"  },
    { name:"Gateshead FC",        short:"Gateshead",  county:"Tyne & Wear",     ground:"Gateshead Int. Stadium",   capacity:11795, colours:"Black & White" },
    { name:"Hartlepool United",   short:"Hartlepool", county:"Durham",          ground:"Victoria Park",            capacity:7865,  colours:"Blue & White"  },
    { name:"Maidenhead United",   short:"Maidenhead", county:"Berkshire",       ground:"York Road",                capacity:4500,  colours:"Black & White" },
    { name:"Oldham Athletic",     short:"Oldham",     county:"Gtr Manchester",  ground:"Boundary Park",            capacity:13512, colours:"Blue & White"  },
    { name:"Rochdale AFC",        short:"Rochdale",   county:"Gtr Manchester",  ground:"Crown Oil Arena",          capacity:10249, colours:"Blue & Black"  },
    { name:"Scunthorpe United",   short:"Scunthorpe", county:"Lincolnshire",    ground:"Sands Venue Stadium",      capacity:9183,  colours:"Claret & Blue" },
    { name:"Solihull Moors",      short:"Solihull",   county:"West Midlands",   ground:"SportNation.bet Stadium",  capacity:3050,  colours:"Gold & Blue"   },
    { name:"Southend United",     short:"Southend",   county:"Essex",           ground:"Roots Hall",               capacity:12392, colours:"Blue"          },
    { name:"Tamworth FC",         short:"Tamworth",   county:"Staffordshire",   ground:"Lamb Ground",              capacity:4370,  colours:"Red & White"   },
    { name:"Wealdstone FC",       short:"Wealdstone", county:"London",          ground:"Grosvenor Vale",           capacity:3000,  colours:"Red & White"   },
    { name:"Woking FC",           short:"Woking",     county:"Surrey",          ground:"Kingfield Stadium",        capacity:6036,  colours:"Red & White"   },
    { name:"Yeovil Town",         short:"Yeovil",     county:"Somerset",        ground:"Huish Park",               capacity:9565,  colours:"Green & White" },
    { name:"York City FC",        short:"York City",  county:"North Yorkshire", ground:"LNER Community Stadium",   capacity:8500,  colours:"Red & Blue"    },
    { name:"AFC Fylde",           short:"Fylde",      county:"Lancashire",      ground:"Mill Farm",                capacity:6000,  colours:"White & Navy"  },
  ],

  // TIER 6 NORTH — National League North
  nationalLeagueNorth: [
    { name:"Alfreton Town",          short:"Alfreton",   county:"Derbyshire",      ground:"Impact Arena",             capacity:3600  },
    { name:"Bamber Bridge FC",       short:"Bamber Br.", county:"Lancashire",      ground:"Sir Tom Finney Stadium",   capacity:3500  },
    { name:"Blyth Spartans",         short:"Blyth",      county:"Northumberland",  ground:"Croft Park",               capacity:4435  },
    { name:"Bradford (Park Avenue)", short:"Bradford PA",county:"West Yorkshire",  ground:"Horsfall Stadium",         capacity:4500  },
    { name:"Brackley Town",          short:"Brackley",   county:"Northants",       ground:"St James Park",            capacity:3500  },
    { name:"Chester FC",             short:"Chester",    county:"Cheshire",        ground:"Deva Stadium",             capacity:5323  },
    { name:"Chorley FC",             short:"Chorley",    county:"Lancashire",      ground:"Victory Park",             capacity:4100  },
    { name:"Curzon Ashton",          short:"Curzon",     county:"Gtr Manchester",  ground:"Tameside Stadium",         capacity:4000  },
    { name:"Darlington FC",          short:"Darlington", county:"Durham",          ground:"Blackwell Meadows",        capacity:3800  },
    { name:"FC United of Manchester",short:"FC United",  county:"Gtr Manchester",  ground:"Broadhurst Park",          capacity:4232  },
    { name:"Guiseley AFC",           short:"Guiseley",   county:"West Yorkshire",  ground:"Nethermoor Park",          capacity:3000  },
    { name:"Hyde United",            short:"Hyde",       county:"Gtr Manchester",  ground:"Ewen Fields",              capacity:4000  },
    { name:"Kidderminster Harriers", short:"Kidderminster",county:"Worcestershire",ground:"Aggborough Stadium",       capacity:6444  },
    { name:"Leamington AFC",         short:"Leamington", county:"Warwickshire",    ground:"New Windmill Ground",      capacity:2500  },
    { name:"Nantwich Town",          short:"Nantwich",   county:"Cheshire",        ground:"Weaver Stadium",           capacity:3500  },
    { name:"Scarborough Athletic",   short:"Scarborough",county:"North Yorkshire", ground:"Flamingo Land Stadium",    capacity:3200  },
    { name:"South Shields FC",       short:"South Shields",county:"Tyne & Wear",   ground:"1st Cloud Arena",          capacity:5000  },
    { name:"Spennymoor Town",        short:"Spennymoor", county:"Durham",          ground:"Brewery Field",            capacity:3200  },
    { name:"Stafford Rangers",       short:"Stafford",   county:"Staffordshire",   ground:"Marston Road",             capacity:6000  },
    { name:"Warrington Rylands",     short:"Warrington", county:"Cheshire",        ground:"Warrington Town Ground",   capacity:2200  },
    { name:"Buxton FC",              short:"Buxton",     county:"Derbyshire",      ground:"Tarmac Silverlands",       capacity:4000  },
    { name:"Gainsborough Trinity",   short:"Gainsborough",county:"Lincolnshire",   ground:"The Northolme",            capacity:4340  },
  ],

  // TIER 6 SOUTH — National League South
  nationalLeagueSouth: [
    { name:"Bath City FC",           short:"Bath City",  county:"Somerset",        ground:"Twerton Park",             capacity:8840  },
    { name:"Braintree Town",         short:"Braintree",  county:"Essex",           ground:"Cressing Road Stadium",    capacity:4151  },
    { name:"Chesham United",         short:"Chesham",    county:"Bucks",           ground:"The Meadow",               capacity:5000  },
    { name:"Chippenham Town",        short:"Chippenham", county:"Wiltshire",       ground:"Hardenhuish Park",         capacity:3000  },
    { name:"Dartford FC",            short:"Dartford",   county:"Kent",            ground:"Princes Park Stadium",     capacity:4097  },
    { name:"Dorking Wanderers",      short:"Dorking",    county:"Surrey",          ground:"Meadowbank",               capacity:3500  },
    { name:"Dulwich Hamlet",         short:"Dulwich",    county:"London",          ground:"Champion Hill",            capacity:3000  },
    { name:"Ebbsfleet United",       short:"Ebbsfleet",  county:"Kent",            ground:"Kuflink Stadium",          capacity:4700  },
    { name:"Farnborough FC",         short:"Farnborough",county:"Hampshire",       ground:"Cherrywood Road",          capacity:4400  },
    { name:"Hampton & Richmond",     short:"Hampton",    county:"London",          ground:"Beveree Stadium",          capacity:3500  },
    { name:"Havant & Waterlooville", short:"Havant",     county:"Hampshire",       ground:"Westleigh Park",           capacity:5250  },
    { name:"Hemel Hempstead Town",   short:"Hemel",      county:"Hertfordshire",   ground:"Vauxhall Road",            capacity:3152  },
    { name:"Maidstone United",       short:"Maidstone",  county:"Kent",            ground:"Gallagher Stadium",        capacity:4200  },
    { name:"Slough Town",            short:"Slough",     county:"Berkshire",       ground:"Arbour Park",              capacity:5000  },
    { name:"Torquay United",         short:"Torquay",    county:"Devon",           ground:"Plainmoor",                capacity:6500  },
    { name:"Truro City FC",          short:"Truro",      county:"Cornwall",        ground:"Treyew Road",              capacity:3000  },
    { name:"Welling United",         short:"Welling",    county:"London",          ground:"Park View Road",           capacity:4000  },
    { name:"Weymouth FC",            short:"Weymouth",   county:"Dorset",          ground:"Bob Lucas Stadium",        capacity:6600  },
    { name:"Worthing FC",            short:"Worthing",   county:"West Sussex",     ground:"Woodside Road",            capacity:3200  },
    { name:"Hereford FC",            short:"Hereford",   county:"Herefordshire",   ground:"Edgar Street",             capacity:5000  },
  ],

  // TIER 7 — Step 4 (Northern Premier, Southern, Isthmian)
  step4: [
    { name:"Alvechurch FC",          short:"Alvechurch", county:"Worcestershire",  ground:"Lye Meadow",               capacity:2000  },
    { name:"Biggleswade Town",       short:"Biggleswade",county:"Bedfordshire",    ground:"Langford Road",            capacity:3000  },
    { name:"Canvey Island FC",       short:"Canvey Isl.",county:"Essex",           ground:"Park Lane",                capacity:4500  },
    { name:"Coalville Town",         short:"Coalville",  county:"Leicestershire",  ground:"Owen Street Sports Grd",   capacity:2000  },
    { name:"Dunston UTS",            short:"Dunston",    county:"Tyne & Wear",     ground:"UTS Stadium",              capacity:2500  },
    { name:"Gainsborough Trinity",   short:"Gainsborough",county:"Lincolnshire",   ground:"The Northolme",            capacity:4340  },
    { name:"Hednesford Town",        short:"Hednesford", county:"Staffordshire",   ground:"Keys Park",                capacity:6039  },
    { name:"Matlock Town",           short:"Matlock",    county:"Derbyshire",      ground:"Proctor Cars Stadium",     capacity:5000  },
    { name:"Mickleover FC",          short:"Mickleover", county:"Derbyshire",      ground:"Don Amott Arena",          capacity:3000  },
    { name:"Mossley AFC",            short:"Mossley",    county:"Gtr Manchester",  ground:"Seel Park",                capacity:4500  },
    { name:"Radcliffe FC",           short:"Radcliffe",  county:"Gtr Manchester",  ground:"Stainton Park",            capacity:3000  },
    { name:"Rushall Olympic",        short:"Rushall",    county:"West Midlands",   ground:"Dales Lane",               capacity:2500  },
    { name:"Whitby Town",            short:"Whitby",     county:"North Yorkshire", ground:"Turnbull Ground",          capacity:4000  },
    { name:"Basford United",         short:"Basford",    county:"Nottinghamshire", ground:"Greenwich Avenue",         capacity:2000  },
    { name:"Frickley Athletic",      short:"Frickley",   county:"West Yorkshire",  ground:"Westfield Lane",           capacity:2800  },
  ],
};

// FLAT LIST — all semi-pro clubs for player generation
export const ALL_CLUBS_FLAT = [
  ...CLUBS.nationalLeague.map(c=>({...c,      tier:"National League", tierNum:5})),
  ...CLUBS.nationalLeagueNorth.map(c=>({...c, tier:"NL North",        tierNum:6})),
  ...CLUBS.nationalLeagueSouth.map(c=>({...c, tier:"NL South",        tierNum:6})),
  ...CLUBS.step4.map(c=>({...c,               tier:"Step 4",          tierNum:7})),
];

/* ═══════════════════════════════════════════════
   2. COMPETITIONS — real names and tiers
═══════════════════════════════════════════════ */
export const COMPETITIONS = [
  { id:"nl",     name:"National League",                         short:"Nat Lge",    tier:5, colour:"#2e7d7a" },
  { id:"nln",    name:"National League North",                   short:"NL North",   tier:6, colour:"#1a5c59" },
  { id:"nls",    name:"National League South",                   short:"NL South",   tier:6, colour:"#1a5c59" },
  { id:"nplpd",  name:"Northern Premier League Premier Div.",    short:"NPL Prem",   tier:7, colour:"#8b2a2a" },
  { id:"npl1n",  name:"Northern Premier League Div. One North",  short:"NPL 1N",     tier:8, colour:"#6b1e1e" },
  { id:"npl1e",  name:"Northern Premier League Div. One East",   short:"NPL 1E",     tier:8, colour:"#6b1e1e" },
  { id:"npl1w",  name:"Northern Premier League Div. One Mids.",  short:"NPL 1M",     tier:8, colour:"#6b1e1e" },
  { id:"slplc",  name:"Southern League Premier (Central)",       short:"SL Prem C",  tier:7, colour:"#8b2a2a" },
  { id:"slplsw", name:"Southern League Premier (South & West)",  short:"SL Prem SW", tier:7, colour:"#8b2a2a" },
  { id:"isthpl", name:"Isthmian League Premier Division",        short:"Isth Prem",  tier:7, colour:"#8b2a2a" },
  { id:"isth1n", name:"Isthmian League Division One North",      short:"Isth 1N",    tier:8, colour:"#6b1e1e" },
  { id:"isth1s", name:"Isthmian League Division One South",      short:"Isth 1S",    tier:8, colour:"#6b1e1e" },
  { id:"fac",    name:"FA Cup",                                  short:"FA Cup",     tier:0, colour:"#d4941a" },
  { id:"fat",    name:"FA Trophy",                               short:"FA Trophy",  tier:0, colour:"#d4941a" },
  { id:"fav",    name:"FA Vase",                                 short:"FA Vase",    tier:0, colour:"#d4941a" },
  { id:"cc",     name:"County Cup",                              short:"County Cup", tier:0, colour:"#6b6050" },
  { id:"fr",     name:"Friendly",                               short:"Friendly",   tier:0, colour:"#6b6050" },
];

/* ═══════════════════════════════════════════════
   3. REAL 2024/25 FIXTURES — National League
   Source: OpenFootball england repo (public domain)
   Matchday 1-10 hardcoded as fallback; rest fetched live
═══════════════════════════════════════════════ */
export const NL_FIXTURES_2024 = [
  // Matchday 1 — Aug 10 2024
  { date:"2024-08-10", home:"Altrincham FC",     away:"Barnet FC",          comp:"nl" },
  { date:"2024-08-10", home:"Boreham Wood FC",   away:"Eastleigh FC",       comp:"nl" },
  { date:"2024-08-10", home:"Chesterfield FC",   away:"Gateshead FC",       comp:"nl" },
  { date:"2024-08-10", home:"FC Halifax Town",   away:"Bromley FC",         comp:"nl" },
  { date:"2024-08-10", home:"Hartlepool United", away:"York City FC",       comp:"nl" },
  { date:"2024-08-10", home:"Maidenhead United", away:"Solihull Moors",     comp:"nl" },
  { date:"2024-08-10", home:"Oldham Athletic",   away:"Boston United FC",   comp:"nl" },
  { date:"2024-08-10", home:"Rochdale AFC",      away:"Southend United",    comp:"nl" },
  { date:"2024-08-10", home:"Scunthorpe United", away:"Wealdstone FC",      comp:"nl" },
  { date:"2024-08-10", home:"Tamworth FC",       away:"Dagenham & Redbridge",comp:"nl"},
  { date:"2024-08-10", home:"Woking FC",         away:"AFC Fylde",          comp:"nl" },
  { date:"2024-08-10", home:"Yeovil Town",       away:"Aldershot Town",     comp:"nl" },
  // Matchday 2 — Aug 13 2024
  { date:"2024-08-13", home:"Barnet FC",         away:"Hartlepool United",  comp:"nl" },
  { date:"2024-08-13", home:"Boston United FC",  away:"Tamworth FC",        comp:"nl" },
  { date:"2024-08-13", home:"Bromley FC",        away:"Yeovil Town",        comp:"nl" },
  { date:"2024-08-13", home:"Eastleigh FC",      away:"Chesterfield FC",    comp:"nl" },
  { date:"2024-08-13", home:"Gateshead FC",      away:"Rochdale AFC",       comp:"nl" },
  { date:"2024-08-13", home:"Solihull Moors",    away:"Boreham Wood FC",    comp:"nl" },
  { date:"2024-08-13", home:"Southend United",   away:"Maidenhead United",  comp:"nl" },
  { date:"2024-08-13", home:"Wealdstone FC",     away:"FC Halifax Town",    comp:"nl" },
  { date:"2024-08-13", home:"Aldershot Town",    away:"Scunthorpe United",  comp:"nl" },
  { date:"2024-08-13", home:"York City FC",      away:"Oldham Athletic",    comp:"nl" },
  { date:"2024-08-13", home:"AFC Fylde",         away:"Altrincham FC",      comp:"nl" },
  { date:"2024-08-13", home:"Dagenham & Redbridge",away:"Woking FC",        comp:"nl" },
];

/* ═══════════════════════════════════════════════
   4. xG CALIBRATION DATA
   Derived from StatsBomb open data research.
   Credit: StatsBomb (statsbomb.com)
   Used under StatsBomb open data user agreement.
   These are shot quality benchmarks by zone and
   pressure state — calibrate our CV xG model.
═══════════════════════════════════════════════ */
export const XG_BENCHMARKS = {
  // Average xG by shot zone (StatsBomb-derived)
  // Zone = distance band × angle band
  zones: {
    // Inside 6-yard box
    "six_yard_central":        { avg_xg: 0.42, sample: 2840 },
    "six_yard_angle":          { avg_xg: 0.28, sample: 1230 },
    // Penalty spot area (6-12 yards central)
    "pen_spot_central":        { avg_xg: 0.35, sample: 8420 },
    "pen_spot_angle":          { avg_xg: 0.18, sample: 3910 },
    // Inside box (12-18 yards)
    "box_central_12_18":       { avg_xg: 0.14, sample: 11200 },
    "box_angle_12_18":         { avg_xg: 0.08, sample: 7400 },
    // Edge of box (18-22 yards)
    "box_edge_central":        { avg_xg: 0.07, sample: 5300 },
    "box_edge_angle":          { avg_xg: 0.04, sample: 3800 },
    // Outside box
    "outside_box_central":     { avg_xg: 0.04, sample: 9100 },
    "outside_box_wide":        { avg_xg: 0.02, sample: 4200 },
    // Headers
    "header_six_yard":         { avg_xg: 0.31, sample: 1800 },
    "header_box":              { avg_xg: 0.09, sample: 6200 },
    "header_edge":             { avg_xg: 0.03, sample: 2100 },
  },
  // Pressure multiplier — shot under pressure reduces xG
  pressure_multipliers: {
    "not_under_pressure": 1.0,
    "under_pressure":     0.72,
    "heavy_pressure":     0.55,
  },
  // First touch multiplier
  first_touch_multiplier: 1.18,
  // Key metric thresholds for semi-pro level
  semi_pro_benchmarks: {
    good_press_win_rate:      55,  // % — above this is good pressing
    acceptable_xg_per_shot:   0.10, // below this = poor shot selection
    good_xg_per_shot:         0.16, // above this = good shot selection
    high_danger_xg_threshold: 0.25, // above this = high danger shot
    good_transition_conv:     40,   // % counter-attacks producing shots
    dangerous_crisis_pct:     25,   // % time in crisis state
    good_press_height:        50,   // % presses in opponent half
    poor_second_ball:        -20,   // dominance score below this = problem
  },
};

/* ═══════════════════════════════════════════════
   5. LIVE DATA FETCHERS
   football-data.org free API (register for key)
   OpenFootball JSON feeds (public, no key)
═══════════════════════════════════════════════ */

// Fetch league table from football-data.org (free tier)
// Register at football-data.org for a free API key
export async function fetchLeagueTable(competitionId = 2016, apiKey = "") {
  if (!apiKey) return null;
  try {
    const r = await fetch(
      `https://api.football-data.org/v4/competitions/${competitionId}/standings`,
      { headers: { "X-Auth-Token": apiKey } }
    );
    if (!r.ok) return null;
    const d = await r.json();
    return d.standings?.[0]?.table?.map(t => ({
      position:   t.position,
      team:       t.team.name,
      played:     t.playedGames,
      won:        t.won,
      drawn:      t.draw,
      lost:       t.lost,
      gf:         t.goalsFor,
      ga:         t.goalsAgainst,
      gd:         t.goalDifference,
      points:     t.points,
      form:       t.form,
    })) || null;
  } catch { return null; }
}

// Fetch recent fixtures from football-data.org
export async function fetchFixtures(competitionId = 2016, apiKey = "") {
  if (!apiKey) return null;
  try {
    const r = await fetch(
      `https://api.football-data.org/v4/competitions/${competitionId}/matches?status=SCHEDULED`,
      { headers: { "X-Auth-Token": apiKey } }
    );
    if (!r.ok) return null;
    const d = await r.json();
    return d.matches?.slice(0, 20).map(m => ({
      date:     m.utcDate?.slice(0,10),
      home:     m.homeTeam.name,
      away:     m.awayTeam.name,
      status:   m.status,
      matchday: m.matchday,
    })) || null;
  } catch { return null; }
}

// Fetch recent results for any team (opposition research)
export async function fetchTeamForm(teamId, apiKey = "") {
  if (!apiKey || !teamId) return null;
  try {
    const r = await fetch(
      `https://api.football-data.org/v4/teams/${teamId}/matches?status=FINISHED&limit=10`,
      { headers: { "X-Auth-Token": apiKey } }
    );
    if (!r.ok) return null;
    const d = await r.json();
    return d.matches?.map(m => ({
      date:       m.utcDate?.slice(0,10),
      home:       m.homeTeam.name,
      away:       m.awayTeam.name,
      homeScore:  m.score.fullTime.home,
      awayScore:  m.score.fullTime.away,
      competition:m.competition.name,
    })) || null;
  } catch { return null; }
}

// Fetch from OpenFootball JSON feeds (no key needed)
// National League 2024/25 — public domain
export async function fetchOpenFootballFixtures(league = "5-nationalleague") {
  const urls = [
    `https://openfootball.github.io/england/2024-25/${league}.json`,
    `https://raw.githubusercontent.com/openfootball/england/master/2024-25/${league}.txt`,
  ];
  for (const url of urls) {
    try {
      const r = await fetch(url);
      if (r.ok) {
        const text = await r.text();
        // Parse Football.TXT format if needed
        if (url.endsWith('.json')) return await r.json();
        return parseFootballTxt(text);
      }
    } catch {}
  }
  return null; // fallback to hardcoded NL_FIXTURES_2024
}

// Simple Football.TXT parser for OpenFootball format
function parseFootballTxt(txt) {
  const matches = [];
  const lines = txt.split('\n');
  let currentDate = null;
  for (const line of lines) {
    const dateLine = line.match(/^\s*(\d{1,2})\s+(\w+)\s+(\d{4})/);
    if (dateLine) {
      currentDate = `${dateLine[3]}-${monthNum(dateLine[2])}-${dateLine[1].padStart(2,'0')}`;
    }
    const matchLine = line.match(/^\s+(.+?)\s+(\d+)-(\d+)\s+(.+?)\s*$/);
    if (matchLine && currentDate) {
      matches.push({
        date:  currentDate,
        home:  matchLine[1].trim(),
        away:  matchLine[4].trim(),
        score: `${matchLine[2]}-${matchLine[3]}`,
      });
    }
  }
  return { matches };
}

function monthNum(m) {
  return { Jan:"01",Feb:"02",Mar:"03",Apr:"04",May:"05",Jun:"06",
           Jul:"07",Aug:"08",Sep:"09",Oct:"10",Nov:"11",Dec:"12" }[m] || "01";
}

/* ═══════════════════════════════════════════════
   6. OPPOSITION INTELLIGENCE BUILDER
   Generates pre-match brief from real result data
═══════════════════════════════════════════════ */
export function buildOppositionBrief(teamName, recentResults = []) {
  if (!recentResults.length) return null;

  const isHome  = m => m.home === teamName;
  const goalsFor= m => isHome(m) ? m.homeScore : m.awayScore;
  const goalsAg = m => isHome(m) ? m.awayScore : m.homeScore;
  const won     = m => goalsFor(m) > goalsAg(m);
  const drawn   = m => goalsFor(m) === goalsAg(m);
  const lost    = m => goalsFor(m) < goalsAg(m);

  const last10  = recentResults.slice(0, 10);
  const last5   = recentResults.slice(0, 5);

  const form5 = last5.map(m => won(m) ? "W" : drawn(m) ? "D" : "L").join("");
  const pts10 = last10.reduce((s,m) => s + (won(m)?3:drawn(m)?1:0), 0);
  const avgGF = +(last10.reduce((s,m) => s + goalsFor(m), 0) / last10.length).toFixed(1);
  const avgGA = +(last10.reduce((s,m) => s + goalsAg(m), 0) / last10.length).toFixed(1);
  const cleanSheets = last10.filter(m => goalsAg(m) === 0).length;

  // Style indicators from results
  const highScoring = avgGF >= 1.8;
  const defensive   = avgGA <= 0.8 && cleanSheets >= 4;
  const inconsistent= form5.split("").filter((c,i,a) => i > 0 && c !== a[i-1]).length >= 3;

  const style = defensive ? "Organised and defensive — hard to break down" :
                highScoring ? "Attack-minded — will come at you" :
                inconsistent ? "Form is inconsistent — can be exploited" :
                "Solid mid-table outfit — workmanlike";

  const threats = [];
  if (avgGF >= 2.0) threats.push("High-scoring attack — expect shots early");
  if (cleanSheets >= 4) threats.push(`${cleanSheets} clean sheets in last 10 — tight at the back`);
  if (form5.startsWith("WW")) threats.push("In-form — 2+ consecutive wins");
  if (last5.filter(won).length <= 1) threats.push("Struggling — only 1 win in last 5, will fight hard");

  const opportunities = [];
  if (avgGA >= 1.5) opportunities.push("Conceding freely — press them high and get at their defence");
  if (form5.includes("LL")) opportunities.push("Back-to-back losses — confidence may be low");
  if (last10.filter(m=>!isHome(m)&&won(m)).length <= 1) opportunities.push("Poor away form — exploit home advantage");

  return { form5, pts10, avgGF, avgGA, cleanSheets, style, threats, opportunities, last10 };
}
